module.exports = __webpack_public_path__ + "img/638-6ada0b.png";